<template>

  <div class="py-4 container-fluid">
    <div class="row">

      <div class="col-md-8">
        <div class="card mb-2">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <p class="mb-0">Crear Producto</p>
              <argon-button color="success" size="sm" class="ms-auto" @click="save" :disabled="isSaving">Guardar</argon-button>
            </div>
          </div>
          <div class="card-body">
            <p class="text-uppercase text-sm">Información</p>
            <div class="row">
              <div class="col-md-8">
                <label for="example-text-input" class="form-control-label">Nombre</label>
                <argon-input type="text" v-model="form.name" />
              </div>

              <div class="col-md-4">
                <label for="example-text-input" class="form-control-label">Referencia</label>
                <input type="text" class="form-control" v-model="form.ref" disabled />
              </div>

              <div class="col-md-8">
                <label for="example-text-input" class="form-control-label">Nombre comercial</label>
                <argon-input type="text" v-model="form.commercial_name" placeholder="Nombre con el que se publica en Shopify" />
                <small class="text-xs text-secondary d-block mt-n2 mb-2">Es el título que se sincroniza con Shopify. Si está vacío se usa el nombre.</small>
              </div>

              <div class="col-md-12">
                <label for="example-text-input" class="form-control-label">Descripción</label>
                <argon-textarea type="text" v-model="form.description" />
              </div>

              <div class="col-md-6">
                <label class="form-control-label">Categoría</label>
                <select ref="categorySelect" class="form-control">
                  <option value=""></option>
                  <option v-for="cat in categoriesList" :key="cat.id" :value="cat.id">{{ cat.name }}</option>
                </select>
              </div>

              <div class="col-md-6" v-if="false">
                <label class="form-control-label">Colección</label>
                <select ref="collectionSelect" class="form-control">
                  <option value=""></option>
                  <option v-for="col in collectionsList" :key="col.id" :value="col.id">{{ col.name }}</option>
                </select>
              </div>

              <div class="col-md-6" v-if="false">
                <label class="form-control-label">Diseño</label>
                <select ref="designSelect" class="form-control">
                  <option value=""></option>
                  <option v-for="des in designsList" :key="des.id" :value="des.id">{{ des.name }}</option>
                </select>
              </div>

              <div class="col-md-6" v-if="false"></div>

              <div class="col-md-6" v-if="false">
                <label for="example-text-input" class="form-control-label">Código de barras</label>
                <div class="input-group">
                  <input type="text" class="form-control" v-model="form.barcode" />
                  
                  <button
                    type="button"
                    class="btn btn-outline-secondary mb-0"
                    title="Imprimir código de barras"
                    @click="openPrintModal(form.barcode, form.name, form.sale_price)"
                    style="border-right: 1px solid #000000 !important;"

                  >
                    <i class="fas fa-barcode"></i>
                  </button>
                </div>
              </div>

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Stock</label>
                <argon-input type="text" v-model="form.quantity" />
              </div>

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Precio de compra</label>
                <argon-input type="text" v-model="form.price" />
              </div>

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Precio de venta</label>
                <argon-input type="text" v-model="form.sale_price" />
              </div>

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Precio de venta 2</label>
                <argon-input type="text" v-model="form.sale_price_2" />
              </div>

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Descuento en catálogo (%)</label>
                <div class="form-group">
                  <input
                    type="text"
                    inputmode="numeric"
                    class="form-control"
                    :value="form.discount_percent > 0 ? form.discount_percent : ''"
                    placeholder="Sin descuento"
                    @input="onDiscountInput"
                  />
                </div>
                <p class="text-muted text-xs mb-0 mt-n2">
                  De 1 a 100. Vacío = se aplica el descuento general de la tienda (Configuración).
                </p>
              </div>

              

              <div class="col-md-12 d-flex align-items-center mt-4 mb-4">
                <div class="form-check form-switch">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="manageStock"
                    v-model="form.manage_stock"
                  />
                  <label class="form-check-label ms-2" for="manageStock">
                    Permitir sobrepedido
                  </label>
                </div>
              </div>

              <br>
              <hr>

              <div class="col-md-4">
                <label for="example-text-input" class="form-control-label">Cant mininima</label>
                <argon-input type="text" v-model="form.low" />
              </div>

              <div class="col-md-4">
                <label for="example-text-input" class="form-control-label">Cant media</label>
                <argon-input type="text" v-model="form.medium" />
              </div>

              <div class="col-md-4">
                <label for="example-text-input" class="form-control-label">Cant alta</label>
                <argon-input type="text" v-model="form.high" />
              </div>

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Bodega</label>
                <select name="" id="" class="form-select" v-model="form.bodega_id">
                  <option value="">Seleccionar</option>
                  <option v-for="bodega in bodegas" :key="bodega.id" :value="bodega.id">
                    {{ bodega.name }}
                  </option>
                </select>
              </div>

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Estado</label>
                <select name="" id="" class="form-select" v-model="form.status">
                  <option value="0">Inactivo</option>
                  <option value="1">Activo</option>
                </select>
              </div>

            </div>
          </div>
        </div>

      </div>

      <!-- Columna lateral: fotos del catálogo y detalles del producto -->
      <div class="col-md-4" v-if="form.id != 0">
        <!-- Fotos adicionales del producto (carrusel del catálogo) -->
        <div class="card mb-2">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <p class="mb-0">Fotos del producto</p>
              <span class="badge badge-secondary ms-auto">{{ productPhotos.length }}</span>
            </div>
          </div>
          <div class="card-body">
            <p class="text-muted text-xs mb-2">
              Fotos que se muestran en el carrusel del catálogo. Si el producto ya tiene imagen principal (Shopify), esa aparece primero.
            </p>
            <input
              type="file"
              accept=".jpg,.jpeg,.png,.webp,image/jpeg,image/png,image/webp"
              multiple
              class="form-control form-control-sm"
              :disabled="uploadingPhotos"
              @change="onProductPhotosSelected"
            />
            <p v-if="uploadingPhotos" class="text-xs text-muted mt-2 mb-0">
              <i class="fas fa-spinner fa-spin me-1"></i> Subiendo {{ uploadedPhotosCount }} de {{ selectedPhotosCount }}...
            </p>

            <div v-if="productPhotos.length" class="inv-photos-grid mt-3">
              <div v-for="ph in productPhotos" :key="ph.id" class="inv-photo-thumb">
                <img :src="productPhotoUrl(ph)" alt="Foto" />
                <button
                  type="button"
                  class="inv-photo-delete"
                  title="Eliminar foto"
                  :disabled="deletingPhotoId === ph.id"
                  @click="deleteProductPhoto(ph)"
                >
                  <i class="fas fa-times"></i>
                </button>
              </div>
            </div>
            <p v-else-if="!uploadingPhotos" class="text-xs text-muted mt-2 mb-0">
              Aún no hay fotos adicionales.
            </p>
          </div>
        </div>

        <!-- Detalles del producto (kubApp) -->
        <div class="card mb-2">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <p class="mb-0">Detalles del producto</p>
            </div>
          </div>
          <div class="card-body">
            <!-- Resumen local -->
            <p class="text-uppercase text-sm">Información local</p>
            <ul class="list-group list-group-flush mb-3">
              <li class="list-group-item d-flex justify-content-between px-0 py-1">
                <span class="text-secondary text-sm">Nombre</span>
                <span class="text-sm text-end">{{ form.name || '-' }}</span>
              </li>
              <li class="list-group-item d-flex justify-content-between px-0 py-1">
                <span class="text-secondary text-sm">Nombre comercial</span>
                <span class="text-sm text-end">{{ form.commercial_name || '-' }}</span>
              </li>
              <li class="list-group-item d-flex justify-content-between px-0 py-1">
                <span class="text-secondary text-sm">Referencia</span>
                <span class="text-sm text-end">{{ form.ref || '-' }}</span>
              </li>
              <li class="list-group-item d-flex justify-content-between px-0 py-1">
                <span class="text-secondary text-sm">Stock</span>
                <span class="text-sm text-end">{{ form.quantity ?? 0 }}</span>
              </li>
              <li class="list-group-item d-flex justify-content-between px-0 py-1">
                <span class="text-secondary text-sm">Precio compra</span>
                <span class="text-sm text-end">{{ formatPrice(form.price) }}</span>
              </li>
              <li class="list-group-item d-flex justify-content-between px-0 py-1">
                <span class="text-secondary text-sm">Precio venta</span>
                <span class="text-sm text-end">{{ formatPrice(form.sale_price) }}</span>
              </li>
              <li class="list-group-item d-flex justify-content-between px-0 py-1">
                <span class="text-secondary text-sm">Precio venta 2</span>
                <span class="text-sm text-end">{{ formatPrice(form.sale_price_2) }}</span>
              </li>
              <li class="list-group-item d-flex justify-content-between px-0 py-1">
                <span class="text-secondary text-sm">Estado</span>
                <span class="text-sm text-end">
                  <span class="badge" :class="Number(form.status) === 1 ? 'bg-success' : 'bg-secondary'">
                    {{ Number(form.status) === 1 ? 'Activo' : 'Inactivo' }}
                  </span>
                </span>
              </li>
              <li class="list-group-item d-flex justify-content-between px-0 py-1">
                <span class="text-secondary text-sm">Bodega</span>
                <span class="text-sm text-end">{{ bodegaNombre(form.bodega_id) }}</span>
              </li>
            </ul>

            <!-- Datos kubApp -->
            <div v-if="!kubappJson">
              <p class="text-uppercase text-sm mb-2">Datos kubApp</p>
              <div class="alert alert-info text-sm mb-0 py-2">
                <i class="fas fa-info-circle me-1"></i>
                Este producto aún no tiene datos sincronizados desde kubApp.
              </div>
            </div>

            <div v-else>
              <p class="text-uppercase text-sm mb-2">Datos kubApp</p>

              <div v-if="kubappProducto">
                <h6 class="text-sm fw-bold mb-1">Producto</h6>
                <ul class="list-group list-group-flush mb-3">
                  <li class="list-group-item d-flex justify-content-between px-0 py-1" v-if="kubappProducto.CodigoProd">
                    <span class="text-secondary text-sm">Código</span>
                    <span class="text-sm text-end">{{ kubappProducto.CodigoProd }}</span>
                  </li>
                  <li class="list-group-item d-flex justify-content-between px-0 py-1" v-if="kubappProducto.NombreProd">
                    <span class="text-secondary text-sm">Nombre</span>
                    <span class="text-sm text-end">{{ kubappProducto.NombreProd }}</span>
                  </li>
                  <li class="list-group-item d-flex justify-content-between px-0 py-1" v-if="kubappProducto.Referencia">
                    <span class="text-secondary text-sm">Referencia</span>
                    <span class="text-sm text-end">{{ kubappProducto.Referencia }}</span>
                  </li>
                  <li class="list-group-item d-flex justify-content-between px-0 py-1" v-if="kubappProducto.UnidadInv">
                    <span class="text-secondary text-sm">Unidad</span>
                    <span class="text-sm text-end">{{ kubappProducto.UnidadInv }}</span>
                  </li>
                  <li class="list-group-item d-flex justify-content-between px-0 py-1" v-if="kubappProducto.NombreFam">
                    <span class="text-secondary text-sm">Familia</span>
                    <span class="text-sm text-end">{{ kubappProducto.NombreFam }}</span>
                  </li>
                  <li class="list-group-item d-flex justify-content-between px-0 py-1" v-if="kubappProducto.NombreGrp">
                    <span class="text-secondary text-sm">Grupo</span>
                    <span class="text-sm text-end">{{ kubappProducto.NombreGrp }}</span>
                  </li>
                  <li class="list-group-item d-flex justify-content-between px-0 py-1" v-if="kubappProducto.NombreProv">
                    <span class="text-secondary text-sm">Proveedor</span>
                    <span class="text-sm text-end">{{ kubappProducto.NombreProv }}</span>
                  </li>
                  <li class="list-group-item d-flex justify-content-between px-0 py-1" v-if="kubappProducto.TarifaIva !== undefined">
                    <span class="text-secondary text-sm">IVA</span>
                    <span class="text-sm text-end">{{ kubappProducto.TarifaIva }}%</span>
                  </li>
                  <li class="list-group-item d-flex justify-content-between px-0 py-1" v-if="kubappProducto.Estado !== undefined">
                    <span class="text-secondary text-sm">Estado</span>
                    <span class="text-sm text-end">{{ kubappProducto.Estado }}</span>
                  </li>
                </ul>
              </div>

              <div v-if="kubappPrecioIva !== null">
                <h6 class="text-sm fw-bold mb-1">Precio</h6>
                <ul class="list-group list-group-flush mb-3">
                  <li class="list-group-item d-flex justify-content-between px-0 py-1">
                    <span class="text-secondary text-sm">Precio + IVA</span>
                    <span class="text-sm text-end">{{ formatPrice(kubappPrecioIva) }}</span>
                  </li>
                </ul>
              </div>

             
            </div>
          </div>
        </div>
      </div>

      <!-- Tabla de variantes del producto -->
      <div class="col-12" v-if="false">
        <div class="card">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <h6>Variantes del Producto (Shopify)</h6>
            </div>
          </div>
          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Título
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      SKU
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Precio
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Gramos
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      ID Shopify
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Código de barras
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(variant, index) in form.shopify_details.variants" :key="index">
                    <td class="align-middle text-sm">
                      {{ variant.title || '-' }}
                    </td>
                    <td class="align-middle text-center text-sm">
                      {{ variant.sku || '-' }}
                    </td>
                    <td class="align-middle text-center text-sm">
                      {{ variant.price ? Number(variant.price).toLocaleString('es-ES', { minimumFractionDigits: 0 }) : '-' }}
                    </td>
                    <td class="align-middle text-center text-sm">
                      {{ variant.grams || '-' }}
                    </td>
                    <td class="align-middle text-center text-sm">
                      {{ variant.id || '-' }}
                    </td>
                    <td class="align-middle text-center text-sm">
                      <div class="input-group input-group-sm">
                        <input type="text" class="form-control form-control-sm" v-model="variant.barcode" placeholder="Código de barras" />
                        <button
                          type="button"
                          class="btn btn-outline-secondary mb-0"
                          title="Imprimir código de barras"
                          @click="openPrintModal(variant.barcode, form.name + (variant.title && variant.title !== 'Default Title' ? ' - ' + variant.title : ''), variant.price || form.sale_price)"
                          style="border-right: 1px solid #000000 !important;border-left: 1px solid #000000 !important;"
                        >
                          <i class="fas fa-barcode"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <!-- Stock por variantes (talla y color) -->
      <div class="col-8" v-if="form.id != 0">
        <div class="card">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center justify-content-between">
              <h6 class="mb-0">Stock por Talla / Color</h6>
              <div class="d-flex gap-2">
                <button
                  type="button"
                  class="btn btn-info btn-sm"
                  @click="printAllVariantLabels"
                  :disabled="printingAllLabels || variantRows.length === 0"
                  title="Generar etiquetas de todas las variantes con stock"
                >
                  <i class="fas" :class="printingAllLabels ? 'fa-spinner fa-spin' : 'fa-print'"></i>
                  Generar etiquetas globales
                </button>
                <button type="button" class="btn btn-primary btn-sm" @click="openBulkVariantModal">
                  <i class="fas fa-plus"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div v-if="variantRows.length === 0" class="text-center text-secondary text-sm py-3">
              No hay variantes configuradas.<br>
              El stock total se maneja con el campo "Stock" de arriba.
            </div>
            <div v-else>
              <input
                ref="variantImageInput"
                type="file"
                accept=".jpg,.jpeg,.png,.webp,image/jpeg,image/png,image/webp"
                class="d-none"
                @change="onVariantImageSelected"
              />
              <div v-for="vr in sortedVariantRows" :key="vr.originalIdx" class="variant-row">
                <div class="variant-image">
                  <button
                    type="button"
                    class="variant-image-btn"
                    :disabled="!variantRows[vr.originalIdx].id || uploadingVariantImageIdx === vr.originalIdx"
                    :title="variantRows[vr.originalIdx].id ? (variantRows[vr.originalIdx].image ? 'Cambiar imagen' : 'Agregar imagen') : 'Guarda la variante para poder agregarle imagen'"
                    @click="pickVariantImage(vr.originalIdx)"
                  >
                    <i v-if="uploadingVariantImageIdx === vr.originalIdx" class="fas fa-spinner fa-spin"></i>
                    <img v-else-if="variantRows[vr.originalIdx].image" :src="productPhotoUrl(variantRows[vr.originalIdx].image)" alt="Imagen variante" />
                    <i v-else class="fas fa-camera"></i>
                  </button>
                  <button
                    v-if="variantRows[vr.originalIdx].image && uploadingVariantImageIdx !== vr.originalIdx"
                    type="button"
                    class="inv-photo-delete variant-image-delete"
                    title="Quitar imagen"
                    @click="deleteVariantImage(vr.originalIdx)"
                  >
                    <i class="fas fa-times"></i>
                  </button>
                </div>
                <div class="input-group input-group-sm" style="flex: 2;">
                  <input type="text" class="form-control form-control-sm" :value="variantRows[vr.originalIdx].barcode" placeholder="Código de barras" disabled readonly />
                </div>
                <select class="form-select form-select-sm" v-model="variantRows[vr.originalIdx].size_id" @change="updateVariantBarcode(vr.originalIdx)" style="flex: 1;">
                  <option :value="null">Talla</option>
                  <option v-for="s in sizesList" :key="s.id" :value="s.id">{{ s.size }}</option>
                </select>
                <select class="form-select form-select-sm" v-model="variantRows[vr.originalIdx].color_id" @change="updateVariantBarcode(vr.originalIdx)" style="flex: 1;">
                  <option :value="null">Color</option>
                  <option v-for="c in colorsList" :key="c.id" :value="c.id">{{ c.name }}</option>
                </select>
                <input type="number" min="0" class="form-control form-control-sm" v-model.number="variantRows[vr.originalIdx].quantity" placeholder="Cant." style="flex: 1;" />
                <button type="button" class="btn btn-outline-info btn-sm mb-0" @click="openBodegaModal(vr.originalIdx)" title="Distribuir stock por bodega">
                  <i class="fas fa-warehouse"></i>
                </button>
                <button type="button" class="btn btn-outline-danger btn-sm mb-0" @click="removeVariantRow(vr.originalIdx)" title="Eliminar">
                  <i class="fas fa-trash"></i>
                </button>
              </div>
              <div class="mt-2 text-sm text-secondary">
                Total variantes: {{ variantTotal }}
              </div>
              <div v-if="bodegaDistributionCount > 0" class="mt-1 text-xs text-muted">
                <i class="fas fa-warehouse me-1"></i>
                {{ bodegaDistributionCount }} variante(s) con distribución por bodega
              </div>
              <button type="button" class="btn btn-success btn-sm w-100 mt-2" @click="saveVariants" :disabled="savingVariants">
                <i class="fas" :class="savingVariants ? 'fa-spinner fa-spin' : 'fa-save'"></i>
                Guardar variantes
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- Modal agregar variantes en lote -->
    <div v-if="showBulkVariantModal" class="barcode-modal-overlay" @click.self="closeBulkVariantModal">
      <div class="barcode-modal card shadow" style="max-width: 500px;">
        <div class="card-body">
          <h6 class="mb-3">Agregar variantes en lote</h6>
          <p class="text-sm text-muted mb-3">Seleccione tallas y colores para generar todas las combinaciones posibles.</p>

          <div class="mb-3">
            <label class="form-control-label text-sm mb-1">Tallas</label>
            <select ref="bulkSizesSelect" multiple class="form-select" style="width:100%;">
              <option v-for="s in sizesList" :key="s.id" :value="s.id">{{ s.size }}</option>
            </select>
          </div>

          <div class="mb-3">
            <label class="form-control-label text-sm mb-1">Colores</label>
            <select ref="bulkColorsSelect" multiple class="form-select" style="width:100%;">
              <option v-for="c in colorsList" :key="c.id" :value="c.id">{{ c.name }}</option>
            </select>
          </div>

          <div class="d-flex gap-2 justify-content-end mt-3">
            <button type="button" class="btn btn-secondary btn-sm" @click="closeBulkVariantModal">Cancelar</button>
            <button type="button" class="btn btn-success btn-sm" @click="confirmBulkVariants">
              <i class="fas fa-check me-1"></i> Generar variantes
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de distribución por bodega de una variante -->
    <div v-if="showBodegaModal" class="barcode-modal-overlay" @click.self="closeBodegaModal">
      <div class="barcode-modal card shadow" style="max-width: 520px;">
        <div class="card-body">
          <div class="d-flex align-items-center justify-content-between mb-3">
            <h6 class="mb-0">
              <i class="fas fa-warehouse me-1"></i>
              Distribución por bodega
            </h6>
            <button type="button" class="btn-close" @click="closeBodegaModal"></button>
          </div>
          <p class="text-xs text-muted mb-3">
            Distribuya el stock de esta variante entre las bodegas. El total se calculará automáticamente.
          </p>

          <div v-if="bodegaModalRows.length === 0" class="text-center text-secondary text-sm py-3">
            No hay bodegas configuradas.
          </div>
          <div v-else>
            <div v-for="row in bodegaModalRows" :key="row.bodega_id" class="bodega-row">
              <span class="bodega-name">{{ row.name }}</span>
              <input type="number" min="0" class="form-control form-control-sm" v-model.number="row.quantity" placeholder="0" style="width: 110px;" />
            </div>

            <div class="mt-3 d-flex align-items-center justify-content-between">
              <span class="text-sm text-secondary">Total variante:</span>
              <span class="badge bg-primary fs-6">{{ bodegaModalTotal }}</span>
            </div>

            <div class="d-flex gap-2 justify-content-end mt-3">
              <button type="button" class="btn btn-secondary btn-sm" @click="closeBodegaModal">Cancelar</button>
              <button type="button" class="btn btn-success btn-sm" @click="saveVariantBodegas" :disabled="savingVariantBodegas">
                <i class="fas" :class="savingVariantBodegas ? 'fa-spinner fa-spin' : 'fa-save'"></i>
                Guardar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de impresión de código de barras -->
    <div v-if="showPrintModal" class="barcode-modal-overlay" @click.self="closePrintModal">
      <div class="barcode-modal card shadow">
        <div class="card-body">
          <h6 class="mb-3">Imprimir código de barras</h6>

          <div v-if="!printData.barcode" class="alert alert-warning py-2 text-sm">
            Este producto no tiene un código de barras asignado.
          </div>

          <template v-else>
            <div class="mb-3">
              <label class="form-control-label">Cantidad de etiquetas a imprimir</label>
              <input type="number" min="1" class="form-control" v-model.number="printData.quantity" />
            </div>

            <p class="text-xs text-muted mb-2">Vista previa de la etiqueta (100 x 50 mm)</p>
            <div class="barcode-preview-wrapper">
              <div class="barcode-label" ref="labelPreview">
                <div class="barcode-label-header">
                  <span class="barcode-label-name">{{ printData.name || 'PRODUCTO' }}</span>
                </div>
                <div class="barcode-label-body">
                  <svg ref="previewSvg"></svg>
                </div>
                <div class="barcode-label-number">{{ printData.barcode }}</div>
              </div>
            </div>
          </template>

          <div class="d-flex gap-2 justify-content-end mt-3">
            <button type="button" class="btn btn-secondary btn-sm" @click="closePrintModal">Cancelar</button>
            <button
              v-if="printData.barcode"
              type="button"
              class="btn btn-success btn-sm"
              @click="printLabels"
            >
              <i class="fas fa-print me-1"></i> Imprimir
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import setNavPills from "../../../assets/js/nav-pills.js";
import setTooltip from "../../../assets/js/tooltip.js";
import ArgonInput from "../../../components/ArgonInput.vue";
import ArgonTextarea from "../../../components/ArgonTextarea.vue";
import ArgonButton from "../../../components/ArgonButton.vue";
import Swal from 'sweetalert2';
import JsBarcode from 'jsbarcode';
import 'select2/dist/css/select2.css';
import 'select2';
import $ from 'jquery';
import inventoryService from '@/services/inventory.service';
import mediaService from '@/services/media.service';

const body = document.getElementsByTagName("body")[0];

export default {
  name: "Models Create",
  data() {
    return {
      showMenu: false,
      isSaving: false,
      form: {
        id: 0,
        name: '',
        commercial_name: '',
        ref: '',
        description: '',
        category_id: null,
        collection_id: null,
        design_id: null,
        barcode: '',
        quantity: 0,
        status: 1,
        bodega_id: null,
        price: 0,
        sale_price: 1,
        sale_price_2: 0,
        discount_percent: 0,
        manage_stock: true,
        low: 100,
        medium: 200,
        high: 300,
      },
      bodegas: [],
      categoriesList: [],
      collectionsList: [],
      designsList: [],
      showPrintModal: false,
      printData: {
        barcode: '',
        name: '',
        price: 0,
        quantity: 3,
      },
      sizesList: [],
      colorsList: [],
      variantRows: [],
      savingVariants: false,
      printingAllLabels: false,
      showBulkVariantModal: false,
      bulkSelectedSizes: [],
      bulkSelectedColors: [],
      showBodegaModal: false,
      bodegaModalVariantIdx: null,
      bodegaModalRows: [],
      savingVariantBodegas: false,
      // Fotos adicionales del producto (media tipo 'inventory')
      productPhotos: [],
      uploadingPhotos: false,
      uploadedPhotosCount: 0,
      selectedPhotosCount: 0,
      deletingPhotoId: null,
      // Imagen por variante (media tipo 'inventory_variant')
      variantImageIdx: null,
      uploadingVariantImageIdx: null,
    };
  },
  components: { ArgonInput, ArgonTextarea, ArgonButton },
  computed: {
    productPhotoUrlBase() {
      return (process.env.VUE_APP_API_IMAGE_URL || '').trim().replace(/\/?$/, '/');
    },
    variantTotal() {
      return this.variantRows.reduce((sum, v) => sum + (Number(v.quantity) || 0), 0);
    },
    bodegaModalTotal() {
      return this.bodegaModalRows.reduce((sum, b) => sum + (Number(b.quantity) || 0), 0);
    },
    bodegaDistributionCount() {
      return this.variantRows.filter(vr => vr.bodegas && vr.bodegas.length > 0).length;
    },
    sortedVariantRows() {
      return [...this.variantRows].map((vr, originalIdx) => ({ ...vr, originalIdx })).sort((a, b) => {
        const sizeA = this.sizesList.find(s => s.id === a.size_id);
        const sizeB = this.sizesList.find(s => s.id === b.size_id);
        const nameA = sizeA ? sizeA.size : '';
        const nameB = sizeB ? sizeB.size : '';
        if (nameA !== nameB) return nameA.localeCompare(nameB, undefined, { numeric: true });
        const colorA = this.colorsList.find(c => c.id === a.color_id);
        const colorB = this.colorsList.find(c => c.id === b.color_id);
        const cNameA = colorA ? colorA.name : '';
        const cNameB = colorB ? colorB.name : '';
        return cNameA.localeCompare(cNameB);
      });
    },
    kubappJson() {
      const raw = this.form?.kubapp_json;
      if (!raw) return null;
      if (typeof raw === 'string') {
        try { return JSON.parse(raw); } catch (e) { return null; }
      }
      return raw;
    },
    kubappProducto() {
      return this.kubappJson?.producto || null;
    },
    kubappInventario() {
      const inv = this.kubappJson?.inventario;
      return Array.isArray(inv) ? inv : [];
    },
    kubappPrecioIva() {
      const v = this.kubappJson?.precio_iva;
      return v === undefined || v === null ? null : v;
    },
    kubappInventarioTotal() {
      return this.kubappInventario.reduce((sum, inv) => sum + (Number(inv.Cantidad) || 0), 0);
    },
    kubappUnidadInv() {
      const u = this.kubappInventario.find(inv => inv.UnidadInv);
      return u ? u.UnidadInv : '';
    },
  },
  watch: {
    'form.ref'() {
      // Recalcular barcodes de todas las variantes cuando cambia la ref del producto
      this.variantRows.forEach((v, idx) => {
        this.variantRows[idx].barcode = this.computeVariantBarcode(v);
      });
    },
  },
  methods: {
    formatPrice(value) {
      const num = Number(value) || 0;
      return '$' + num.toLocaleString('es-CO', { minimumFractionDigits: 0 });
    },
    bodegaNombre(id) {
      if (!id) return '-';
      const b = this.bodegas.find(x => String(x.id) === String(id));
      return b ? b.name : '-';
    },
    openPrintModal(barcode, name, price) {
      this.printData = {
        barcode: barcode ? String(barcode).trim() : '',
        name: (name || '').toUpperCase(),
        price: price || 0,
        quantity: 3,
      };
      this.showPrintModal = true;
      if (this.printData.barcode) {
        this.$nextTick(() => this.renderPreviewBarcode());
      }
    },
    closePrintModal() {
      this.showPrintModal = false;
    },
    renderPreviewBarcode() {
      if (!this.$refs.previewSvg) return;
      try {
        JsBarcode(this.$refs.previewSvg, this.printData.barcode, {
          format: 'CODE128',
          displayValue: true,
          fontSize: 12,
          height: 50,
          margin: 0,
          width: 1,
        });
      } catch (e) {
        console.error('Error generando código de barras:', e);
      }
    },
    printLabels() {
      const qty = Math.max(1, parseInt(this.printData.quantity) || 1);

      // Generar SVG del código de barras
      const tmpSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      try {
        JsBarcode(tmpSvg, this.printData.barcode, {
          format: 'CODE128',
          displayValue: false,
          fontSize: 12,
          height: 50,
          margin: 0,
          width: 2,
        });
      } catch (e) {
        Swal.fire('Error', 'No se pudo generar el código de barras.', 'error');
        return;
      }
      const barcodeSvg = new XMLSerializer().serializeToString(tmpSvg);

      const name = this.printData.name || 'PRODUCTO';

      const labelHtml = `
          <div class="label">
            <div class="label-header">
              <span class="label-name">${name}</span>
            </div>
            <div class="label-body">${barcodeSvg}</div>
            <div class="label-number">${this.printData.barcode}</div>
          </div>`;

      let rows = '';
      const total = qty;
      const remainder = total % 3;
      const padded = remainder > 0 ? total + (3 - remainder) : total;
      for (let i = 0; i < padded; i++) {
        if (i % 3 === 0) rows += '<div class="label-row">';
        if (i < total) {
          rows += labelHtml;
        } else {
          rows += '<div class="label label-empty"></div>';
        }
        if (i % 3 === 2 || i === padded - 1) rows += '</div>';
      }

      const html = `
        <!DOCTYPE html>
        <html>
        <head>
          <meta charset="utf-8" />
          <title>Imprimir códigos de barras</title>
          <style>
            @page { size: 104mm 25mm; margin: 0; }
            * { box-sizing: border-box; }
            html, body { margin: 0; padding: 0; }
            .label-row {
              display: flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;
              width: 104mm;
              height: 25mm;
              page-break-after: always;
            }
            .label {
              width: 34mm;
              height: 25mm;
              padding: 4mm;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              font-family: Arial, Helvetica, sans-serif;
              overflow: hidden;
            }
            .label-empty {
              visibility: hidden;
            }
            .label-header {
              display: flex;
              justify-content: space-between;
              align-items: flex-start;
              width: 100%;
            }
            .label-name {
              font-size: 7pt;
              font-weight: bold;
              word-break: break-word;
              line-height: 1.1;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .label-price {
              font-size: 7pt;
              font-weight: bold;
            }
            .label-body {
              flex: 1;
              display: flex;
              align-items: center;
              justify-content: center;
              width: 100%;
            }
            .label-body svg {
              width: 100%;
              height: auto;
              min-height: 10mm;
              display: block;
            }
            .label-number {
              font-size: 7pt;
              font-weight: bold;
              text-align: center;
              width: 100%;
              letter-spacing: 0.5pt;
            }
          </style>
        </head>
        <body onload="window.onafterprint = function(){ window.close(); }; setTimeout(function(){ window.print(); }, 100);">
          ${rows}
        </body>
        </html>`;

      const printWindow = window.open('', '_blank', 'width=800,height=600');
      if (!printWindow) {
        Swal.fire('Bloqueado', 'Permita las ventanas emergentes para imprimir.', 'warning');
        return;
      }
      printWindow.document.open();
      printWindow.document.write(html);
      printWindow.document.close();

      this.closePrintModal();
    },
    printAllVariantLabels() {
      // Filtrar variantes con cantidad > 0 y barcode válido
      const variants = this.variantRows.filter(vr => {
        const qty = parseInt(vr.quantity) || 0;
        const bc = vr.barcode ? String(vr.barcode).trim() : '';
        return qty > 0 && bc;
      });

      if (variants.length === 0) {
        Swal.fire('Sin variantes', 'No hay variantes con stock y código de barras para generar etiquetas.', 'warning');
        return;
      }

      const totalLabels = variants.reduce((sum, v) => sum + (parseInt(v.quantity) || 0), 0);

      Swal.fire({
        title: 'Generar etiquetas globales',
        text: `Se generarán ${totalLabels} etiquetas de ${variants.length} variante(s).`,
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Imprimir',
        cancelButtonText: 'Cancelar',
      }).then(result => {
        if (!result.isConfirmed) return;

        this.printingAllLabels = true;

        // Generar los barcodes SVG de cada variante
        const labels = [];
        for (const vr of variants) {
          const qty = parseInt(vr.quantity) || 0;
          const bc = String(vr.barcode).trim();
          const sizeName = this.sizesList.find(s => s.id === vr.size_id)?.size || '';
          const colorName = this.colorsList.find(c => c.id === vr.color_id)?.name || '';
          const variantLabel = [sizeName, colorName].filter(Boolean).join(' ');
          const name = (this.form.name || 'PRODUCTO') + (variantLabel ? ' - ' + variantLabel : '');

          const tmpSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          try {
            JsBarcode(tmpSvg, bc, {
              format: 'CODE128',
              displayValue: false,
              fontSize: 12,
              height: 50,
              margin: 0,
              width: 2,
            });
          } catch (e) {
            console.error('Error generando barcode para variante:', bc, e);
            continue;
          }
          const barcodeSvg = new XMLSerializer().serializeToString(tmpSvg);

          const labelHtml = `
              <div class="label">
                <div class="label-header">
                  <span class="label-name">${name}</span>
                </div>
                <div class="label-body">${barcodeSvg}</div>
                <div class="label-number">${bc}</div>
              </div>`;

          for (let i = 0; i < qty; i++) {
            labels.push(labelHtml);
          }
        }

        if (labels.length === 0) {
          Swal.fire('Error', 'No se pudieron generar las etiquetas.', 'error');
          this.printingAllLabels = false;
          return;
        }

        // Agrupar de a 3 por fila
        let rows = '';
        const total = labels.length;
        const remainder = total % 3;
        const padded = remainder > 0 ? total + (3 - remainder) : total;
        for (let i = 0; i < padded; i++) {
          if (i % 3 === 0) rows += '<div class="label-row">';
          if (i < total) {
            rows += labels[i];
          } else {
            rows += '<div class="label label-empty"></div>';
          }
          if (i % 3 === 2 || i === padded - 1) rows += '</div>';
        }

        const html = `
          <!DOCTYPE html>
          <html>
          <head>
            <meta charset="utf-8" />
            <title>Imprimir etiquetas globales</title>
            <style>
              @page { size: 104mm 25mm; margin: 0; }
              * { box-sizing: border-box; }
              html, body { margin: 0; padding: 0; }
              .label-row {
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                width: 104mm;
                height: 25mm;
                page-break-after: always;
              }
              .label {
                width: 34mm;
                height: 25mm;
                padding: 4mm;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                font-family: Arial, Helvetica, sans-serif;
                overflow: hidden;
              }
              .label-empty { visibility: hidden; }
              .label-header {
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                width: 100%;
              }
              .label-name {
                font-size: 8pt;
                font-weight: bold;
                word-break: break-word;
                line-height: 1.1;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              .label-body {
                flex: 1;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 100%;
              }
              .label-body svg {
                width: 100%;
                height: auto;
                max-height: 7mm;
                display: block;
              }
              .label-number {
                font-size: 8pt;
                font-weight: bold;
                text-align: center;
                width: 100%;
                letter-spacing: 0.5pt;
              }
            </style>
          </head>
          <body onload="window.onafterprint = function(){ window.close(); }; setTimeout(function(){ window.print(); }, 100);">
            ${rows}
          </body>
          </html>`;

        const printWindow = window.open('', '_blank', 'width=800,height=600');
        if (!printWindow) {
          Swal.fire('Bloqueado', 'Permita las ventanas emergentes para imprimir.', 'warning');
          this.printingAllLabels = false;
          return;
        }
        printWindow.document.open();
        printWindow.document.write(html);
        printWindow.document.close();

        this.printingAllLabels = false;
      });
    },
    // Descuento: solo enteros de 1 a 100; más de 100 queda en 100 y 0 o vacío = sin descuento propio
    onDiscountInput(e) {
      const digits = String(e.target.value).replace(/\D/g, '');
      const n = digits === '' ? 0 : Math.min(100, parseInt(digits, 10));
      this.form.discount_percent = n;
      e.target.value = n > 0 ? n : '';
    },
    async loadProductPhotos(id = null) {
      const productId = id ?? this.form.id;
      if (!productId) return;
      try {
        const res = await mediaService.getData(productId);
        this.productPhotos = (res.data || []).filter(m => m.mediaable_type === 'inventory');
      } catch (e) {
        console.error('Error loading product photos:', e);
      }
    },
    productPhotoUrl(ph) {
      return this.productPhotoUrlBase + String(ph.file_path).replace(/^\/+/, '');
    },
    async onProductPhotosSelected(event) {
      const selected = Array.from(event.target.files || []);
      event.target.value = '';
      if (!selected.length || !this.form.id) return;
      const allowedExt = ['jpg', 'jpeg', 'png', 'webp'];
      const maxBytes = 10 * 1024 * 1024;
      const rejected = [];
      const files = selected.filter(file => {
        const ext = (file.name.split('.').pop() || '').toLowerCase();
        if (!allowedExt.includes(ext)) {
          rejected.push(`"${file.name}": formato no permitido (solo JPG, PNG o WEBP)`);
          return false;
        }
        if (file.size > maxBytes) {
          rejected.push(`"${file.name}": supera los 10 MB`);
          return false;
        }
        return true;
      });
      if (rejected.length) {
        const esc = t => t.replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
        Swal.fire({ icon: 'warning', title: 'Fotos no válidas', html: rejected.map(esc).join('<br>') });
      }
      if (!files.length) return;
      this.uploadingPhotos = true;
      this.uploadedPhotosCount = 0;
      this.selectedPhotosCount = files.length;
      let ok = 0;
      for (const file of files) {
        try {
          const formData = new FormData();
          formData.append('mediaable_id', this.form.id);
          formData.append('mediaable_type', 'inventory');
          formData.append('file', file);
          await mediaService.createData(formData);
          ok++;
        } catch (e) {
          console.error('Error uploading photo:', e);
          const data = e?.response?.data;
          const detail = data?.errors?.file?.[0]
            || data?.message
            || (e?.response?.status === 413 ? 'El archivo es demasiado grande.' : '');
          Swal.fire('Error', `No se pudo subir la foto "${file.name}".${detail ? ' ' + detail : ''}`, 'error');
        }
        this.uploadedPhotosCount = ok;
      }
      this.uploadingPhotos = false;
      await this.loadProductPhotos();
      if (ok > 0) {
        Swal.fire({
          icon: 'success',
          title: 'Fotos subidas',
          text: `${ok} foto(s) agregada(s) al producto.`,
          timer: 1800,
          showConfirmButton: false,
        });
      }
    },
    async deleteProductPhoto(ph) {
      const confirm = await Swal.fire({
        icon: 'warning',
        title: 'Eliminar foto',
        text: '¿Seguro que deseas eliminar esta foto del producto?',
        showCancelButton: true,
        confirmButtonText: 'Eliminar',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#f5365c',
      });
      if (!confirm.isConfirmed) return;
      this.deletingPhotoId = ph.id;
      try {
        await mediaService.deleteData(ph.id);
        this.productPhotos = this.productPhotos.filter(p => p.id !== ph.id);
      } catch (e) {
        console.error('Error deleting photo:', e);
        Swal.fire('Error', 'No se pudo eliminar la foto.', 'error');
      } finally {
        this.deletingPhotoId = null;
      }
    },
    normalizeBoolean(value) {
      if (value === undefined || value === null) {
        return true;
      }
      if (typeof value === 'string') {
        return value === '1' || value.toLowerCase() === 'true';
      }
      return value === 1 || value === true;
    },
    async loadInventoryData(id) {
      try {
        const res = await inventoryService.getData(id);
        if (res.data) {
          const data = res.data.data || res.data;
          this.form = {
            ...this.form,
            ...data,
            collection_id: data.collection_id ?? null,
            design_id: data.design_id ?? null,
            manage_stock: this.normalizeBoolean(data.manage_stock),
          };
          this.$nextTick(() => {
            this.initCategorySelect2();
            this.initCollectionSelect2();
            this.initDesignSelect2();
            this.updateConcatenatedRef();
          });
          this.loadVariants();
        }
      } catch (error) {
        console.error('Error al cargar los datos del inventario:', error);
        Swal.fire('Error', 'No se pudieron cargar los datos del producto', 'error');
      }
    },
    async getBodegas() {
      this.bodegas = await this.$store.dispatch('bodegas/getAll');
      if (this.bodegas && this.bodegas.length > 0 && !this.form.bodega_id) {
        this.form.bodega_id = this.bodegas[0].id;
      }
    },
    async loadCategories() {
      try {
        const res = await this.$store.dispatch('categories/getCategories');
        this.categoriesList = res?.data || [];
      } catch (e) {
        console.error('Error loading categories:', e);
        this.categoriesList = [];
      }
    },
    async loadCollections() {
      try {
        const res = await this.$store.dispatch('collections/getCollections');
        this.collectionsList = res?.data || [];
      } catch (e) {
        console.error('Error loading collections:', e);
        this.collectionsList = [];
      }
    },
    async loadDesigns() {
      try {
        const res = await this.$store.dispatch('designs/getDesigns');
        this.designsList = res?.data || [];
      } catch (e) {
        console.error('Error loading designs:', e);
        this.designsList = [];
      }
    },
    updateConcatenatedRef() {
      // La categoría no entra en la referencia: solo agrupa el producto en el catálogo
      const col = this.collectionsList.find(c => c.id === this.form.collection_id);
      const des = this.designsList.find(d => d.id === this.form.design_id);
      const parts = [col?.code, des?.code].filter(p => p && String(p).trim() !== '');
      const concatenated = parts.join('');

      // Si hay código concatenado de categoría/colección/diseño, usarlo.
      // Si no, usar el CodigoProd de kubApp (o el ref existente) como referencia.
      if (concatenated) {
        this.form.ref = concatenated;
      } else {
        const kubappCodigoProd = this.kubappProducto?.CodigoProd || '';
        this.form.ref = kubappCodigoProd || this.form.ref || '';
      }
      this.form.barcode = this.form.ref;
    },
    initCategorySelect2() {
      const $sel = $(this.$refs.categorySelect);
      $sel.select2({
        placeholder: 'Seleccionar categoría',
        width: '100%',
        allowClear: true,
      }).on('change', () => {
        const val = $sel.val();
        this.form.category_id = val ? Number(val) : null;
        this.updateConcatenatedRef();
      });
      // Setear valor actual
      $sel.val(this.form.category_id || '').trigger('change');
    },
    initCollectionSelect2() {
      const $sel = $(this.$refs.collectionSelect);
      $sel.select2({
        placeholder: 'Seleccionar colección',
        width: '100%',
        allowClear: true,
      }).on('change', () => {
        const val = $sel.val();
        this.form.collection_id = val ? Number(val) : null;
        this.updateConcatenatedRef();
      });
      $sel.val(this.form.collection_id || '').trigger('change');
    },
    initDesignSelect2() {
      const $sel = $(this.$refs.designSelect);
      $sel.select2({
        placeholder: 'Seleccionar diseño',
        width: '100%',
        allowClear: true,
      }).on('change', () => {
        const val = $sel.val();
        this.form.design_id = val ? Number(val) : null;
        this.updateConcatenatedRef();
      });
      $sel.val(this.form.design_id || '').trigger('change');
    },
    async loadSizesAndColors() {
      try {
        const [sizesRes, colorsRes] = await Promise.all([
          this.$store.dispatch('tallas/getAll'),
          this.$store.dispatch('colors/getColors'),
        ]);
        this.sizesList = sizesRes || [];
        this.colorsList = colorsRes?.data || [];
      } catch (e) {
        console.error('Error loading sizes/colors:', e);
      }
    },
    async loadVariants() {
      if (this.form.id === 0) return;
      try {
        const res = await inventoryService.getVariants(this.form.id);
        this.variantRows = (res.data || []).map(v => {
          const variant = {
            id: v.id,
            size_id: v.size_id,
            color_id: v.color_id,
            quantity: v.quantity,
            barcode: '',
            image: v.image || null,
            bodegas: (v.bodegas || []).map(b => ({ bodega_id: b.bodega_id, quantity: b.quantity })),
          };
          variant.barcode = this.computeVariantBarcode(variant);
          return variant;
        });
      } catch (e) {
        console.error('Error loading variants:', e);
      }
    },
    computeVariantBarcode(variant) {
      const ref = this.form.ref || '';
      const color = this.colorsList.find(c => c.id === variant.color_id);
      const size = this.sizesList.find(s => s.id === variant.size_id);
      const parts = [ref, color?.code || '', size?.code || ''].filter(p => p && String(p).trim() !== '');
      return parts.join('');
    },
    updateVariantBarcode(idx) {
      this.variantRows[idx].barcode = this.computeVariantBarcode(this.variantRows[idx]);
    },
    addVariantRow() {
      const newVariant = { size_id: null, color_id: null, quantity: 0, barcode: '', image: null, bodegas: [] };
      this.variantRows.push(newVariant);
    },
    openBulkVariantModal() {
      this.showBulkVariantModal = true;
      this.$nextTick(() => {
        const $sizes = $(this.$refs.bulkSizesSelect);
        const $colors = $(this.$refs.bulkColorsSelect);

        $sizes.select2({
          placeholder: 'Seleccionar tallas',
          width: '100%',
          closeOnSelect: false,
        }).on('change', () => {
          this.bulkSelectedSizes = $sizes.val() || [];
        });

        $colors.select2({
          placeholder: 'Seleccionar colores',
          width: '100%',
          closeOnSelect: false,
        }).on('change', () => {
          this.bulkSelectedColors = $colors.val() || [];
        });
      });
    },
    closeBulkVariantModal() {
      this.showBulkVariantModal = false;
      this.bulkSelectedSizes = [];
      this.bulkSelectedColors = [];
      this.$nextTick(() => {
        if (this.$refs.bulkSizesSelect) $(this.$refs.bulkSizesSelect).val(null).trigger('change');
        if (this.$refs.bulkColorsSelect) $(this.$refs.bulkColorsSelect).val(null).trigger('change');
      });
    },
    confirmBulkVariants() {
      const sizeIds = this.bulkSelectedSizes.map(Number);
      const colorIds = this.bulkSelectedColors.map(Number);

      if (sizeIds.length === 0 && colorIds.length === 0) {
        Swal.fire('Atención', 'Seleccione al menos una talla o un color.', 'warning');
        return;
      }

      const finalSizeIds = sizeIds.length > 0 ? sizeIds : [null];
      const finalColorIds = colorIds.length > 0 ? colorIds : [null];

      finalSizeIds.forEach(sid => {
        finalColorIds.forEach(cid => {
          const exists = this.variantRows.some(vr => vr.size_id === sid && vr.color_id === cid);
          if (!exists) {
            const newVariant = { size_id: sid, color_id: cid, quantity: 0, barcode: '', image: null, bodegas: [] };
            newVariant.barcode = this.computeVariantBarcode(newVariant);
            this.variantRows.push(newVariant);
          }
        });
      });

      this.closeBulkVariantModal();
    },
    async removeVariantRow(idx) {
      const vr = this.variantRows[idx];
      if (!vr) return;

      // Si la variante ya existe en BD (tiene id), verificar si esta en uso
      if (vr.id) {
        try {
          const checkRes = await inventoryService.checkVariantUsage(vr.id);
          if (checkRes.data.in_use) {
            const sizeName = this.sizesList.find(s => s.id === vr.size_id)?.size || '';
            const colorName = this.colorsList.find(c => c.id === vr.color_id)?.name || '';
            const label = [sizeName, colorName].filter(Boolean).join(' ') || `Variante #${vr.id}`;
            await Swal.fire({
              title: 'No se puede eliminar',
              html: `La variante <strong>${label}</strong> esta asociada a <strong>${checkRes.data.count}</strong> pedido(s) y no puede ser eliminada.`,
              icon: 'error',
              confirmButtonText: 'Entendido',
              confirmButtonColor: '#d33',
            });
            return;
          }
        } catch (e) {
          console.error('Error al verificar uso de variante:', e);
        }
      }

      const result = await Swal.fire({
        title: '¿Eliminar variante?',
        text: '¿Estás seguro de que deseas eliminar esta variante?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#d33',
      });
      if (result.isConfirmed) {
        this.variantRows.splice(idx, 1);
      }
    },
    async saveVariants() {
      this.savingVariants = true;
      try {
        await inventoryService.saveVariants(this.form.id, this.variantRows);
        await Swal.fire('Éxito', 'Variantes guardadas correctamente', 'success');
        await this.loadVariants();
        const invRes = await inventoryService.getData(this.form.id);
        if (invRes.data) {
          this.form.quantity = invRes.data.quantity;
        }
      } catch (e) {
        console.error('Error saving variants:', e);
        const msg = e.response?.data?.message || 'No se pudieron guardar las variantes';
        await Swal.fire('Error', msg, 'error');
      } finally {
        this.savingVariants = false;
      }
    },
    pickVariantImage(idx) {
      if (!this.variantRows[idx]?.id) return;
      this.variantImageIdx = idx;
      this.$refs.variantImageInput.click();
    },
    async onVariantImageSelected(event) {
      const file = (event.target.files || [])[0];
      event.target.value = '';
      const idx = this.variantImageIdx;
      this.variantImageIdx = null;
      const vr = this.variantRows[idx];
      if (!file || !vr?.id) return;
      const ext = (file.name.split('.').pop() || '').toLowerCase();
      if (!['jpg', 'jpeg', 'png', 'webp'].includes(ext)) {
        Swal.fire('Imagen no válida', 'Solo se permiten imágenes JPG, PNG o WEBP.', 'warning');
        return;
      }
      if (file.size > 10 * 1024 * 1024) {
        Swal.fire('Imagen no válida', 'La imagen no debe superar los 10 MB.', 'warning');
        return;
      }
      this.uploadingVariantImageIdx = idx;
      try {
        const formData = new FormData();
        formData.append('mediaable_id', vr.id);
        formData.append('mediaable_type', 'inventory_variant');
        formData.append('file', file);
        const res = await mediaService.createData(formData);
        // Una sola imagen por variante: al subir una nueva se elimina la anterior
        const previous = vr.image;
        vr.image = { id: res.data.id, file_path: res.data.file_path };
        if (previous?.id) {
          await mediaService.deleteData(previous.id).catch(e => console.error('Error deleting previous variant image:', e));
        }
      } catch (e) {
        console.error('Error uploading variant image:', e);
        const data = e?.response?.data;
        const detail = data?.errors?.file?.[0] || data?.message || '';
        Swal.fire('Error', `No se pudo subir la imagen de la variante.${detail ? ' ' + detail : ''}`, 'error');
      } finally {
        this.uploadingVariantImageIdx = null;
      }
    },
    async deleteVariantImage(idx) {
      const vr = this.variantRows[idx];
      if (!vr?.image) return;
      const confirm = await Swal.fire({
        icon: 'warning',
        title: 'Quitar imagen',
        text: '¿Seguro que deseas quitar la imagen de esta variante?',
        showCancelButton: true,
        confirmButtonText: 'Quitar',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#f5365c',
      });
      if (!confirm.isConfirmed) return;
      this.uploadingVariantImageIdx = idx;
      try {
        await mediaService.deleteData(vr.image.id);
        vr.image = null;
      } catch (e) {
        console.error('Error deleting variant image:', e);
        Swal.fire('Error', 'No se pudo quitar la imagen.', 'error');
      } finally {
        this.uploadingVariantImageIdx = null;
      }
    },
    variantBodegaTotal(idx) {
      const vr = this.variantRows[idx];
      if (!vr || !vr.bodegas || vr.bodegas.length === 0) return null;
      return vr.bodegas.reduce((sum, b) => sum + (Number(b.quantity) || 0), 0);
    },
    openBodegaModal(idx) {
      const vr = this.variantRows[idx];
      if (!vr) return;
      if (!vr.id) {
        Swal.fire('Atención', 'Guarda primero las variantes para poder distribuir stock por bodega.', 'warning');
        return;
      }
      this.bodegaModalVariantIdx = idx;
      // Construir filas: una por cada bodega existente, con la cantidad guardada (0 si no hay)
      this.bodegaModalRows = this.bodegas.map(b => {
        const saved = (vr.bodegas || []).find(x => x.bodega_id === b.id);
        return { bodega_id: b.id, name: b.name, quantity: saved ? saved.quantity : 0 };
      });
      this.showBodegaModal = true;
    },
    closeBodegaModal() {
      this.showBodegaModal = false;
      this.bodegaModalVariantIdx = null;
      this.bodegaModalRows = [];
    },
    async saveVariantBodegas() {
      const idx = this.bodegaModalVariantIdx;
      if (idx === null) return;
      const vr = this.variantRows[idx];
      if (!vr || !vr.id) return;

      this.savingVariantBodegas = true;
      try {
        const payload = this.bodegaModalRows
          .filter(b => Number(b.quantity) > 0)
          .map(b => ({ bodega_id: b.bodega_id, quantity: Number(b.quantity) || 0 }));
        const res = await inventoryService.syncVariantBodegas(vr.id, payload);
        // Actualizar la variante local con la distribución y el nuevo total
        this.variantRows[idx].bodegas = payload;
        this.variantRows[idx].quantity = res.data.quantity;
        // Cerrar el modal antes de mostrar el Swal para que no quede detrás
        this.closeBodegaModal();
        // Actualizar el stock total del producto padre
        const invRes = await inventoryService.getData(this.form.id);
        if (invRes.data) {
          this.form.quantity = invRes.data.quantity;
        }
        await Swal.fire('Éxito', 'Distribución por bodega guardada', 'success');
      } catch (e) {
        console.error('Error saving variant bodegas:', e);
        const msg = e.response?.data?.message || 'No se pudo guardar la distribución';
        await Swal.fire('Error', msg, 'error');
      } finally {
        this.savingVariantBodegas = false;
      }
    },
    async save() {
      // Evitar doble guardado
      if (this.isSaving) {
        return;
      }

      try {
        // Activar estado de guardado
        this.isSaving = true;

        // Mostrar modal de carga
        Swal.fire({
          title: 'Guardando...',
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });

        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("inventory/save", this.form);
        
        // Cerrar modal de carga
        Swal.close();

        if (response && response.status >= 200 && response.status < 300) {
          // Actualizar el formulario con los datos guardados
          const createdId = response.data?.data?.id || response.data?.id;
          if (createdId) {
            this.form.id = createdId;
          }
          
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El insumo ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          });

          // Redirigir a la edición del producto recién creado para agregar variantes
          this.$router.push({
            name: 'Inventory Edit',
            params: { id: this.form.id },
          });

        } else {
          throw new Error(response.data.message || 'Error al guardar el proyecto');
        }

      } catch (error) {
        // Cerrar modal de carga en caso de error
        Swal.close();
        console.error("Error al crear el proyecto:", error);
        const errData = error?.data || error?.response?.data;
        const msg = errData?.errors?.ref?.[0] || errData?.message || error?.message || 'Error al guardar el proyecto';
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: msg,
        });
      } finally {
        // Desactivar estado de guardado
        this.isSaving = false;
      }
    },
  },
  async mounted() {
    this.getBodegas();
    this.loadSizesAndColors();
    await this.loadCategories();
    await this.loadCollections();
    await this.loadDesigns();

    const editId = this.$route.params.id;

    if (editId) {
      this.loadInventoryData(editId);
      this.loadProductPhotos(editId);
    } else {
      this.$nextTick(() => {
        this.initCategorySelect2();
        this.initCollectionSelect2();
        this.initDesignSelect2();
      });
    }

    if (this.form.id === 0 && !this.form.barcode) {
      this.form.barcode = String(Math.floor(100000000 + Math.random() * 900000000));
    }

    this.$store.state.isAbsolute = false;
    setNavPills();
    setTooltip();
  },
  beforeMount() {
    this.$store.state.imageLayout = "profile-overview";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = true;
    body.classList.add("profile-overview");
  },
  beforeUnmount() {
    this.$store.state.isAbsolute = false;
    this.$store.state.imageLayout = "default";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = false;
    body.classList.remove("profile-overview");
  }
};
</script>

<style>
.disabled-link {
  color: gray;
  pointer-events: none;
  /* Impide la interacción */
  cursor: not-allowed;
  /* Cambia el cursor para indicar que está deshabilitado */
}

.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.page-item {
  margin: 0 5px;
}

.active {
  font-weight: bold;
  /* Estilo para la página activa */
}

/* Modal de impresión de código de barras */
.barcode-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1080;
}
.barcode-modal {
  width: 100%;
  max-width: 480px;
  margin: 1rem;
}
.select2-container--open {
  z-index: 9999;
}
.select2-dropdown {
  z-index: 9999;
}
.barcode-preview-wrapper {
  display: flex;
  justify-content: center;
  background: #f6f7f9;
  border: 1px dashed #ccc;
  border-radius: 6px;
  padding: 10px;
}
.barcode-label {
  width: 100mm;
  height: 50mm;
  max-width: 100%;
  background: #fff;
  border: 1px solid #ddd;
  padding: 4mm;
  display: flex;
  flex-direction: column;
  transform-origin: top center;
}
.barcode-label-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
}
.barcode-label-name {
  font-size: 12pt;
  font-weight: bold;
  max-width: 60mm;
  word-break: break-word;
}
.barcode-label-price {
  font-size: 14pt;
  font-weight: bold;
}
.barcode-label-body {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.barcode-label-body svg {
  max-width: 90mm;
  max-height: 25mm;
}
.barcode-label-number {
  font-size: 10pt;
  font-weight: bold;
  text-align: center;
  width: 100%;
  letter-spacing: 1pt;
}

.variant-row {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
}
.variant-row select,
.variant-row input {
  margin-bottom: 0;
}
.variant-row .btn-link {
  margin: 0;
  padding: 0;
  border: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}
/* Imagen por variante */
.variant-image {
  position: relative;
  flex: 0 0 38px;
}
.variant-image-btn {
  width: 38px;
  height: 38px;
  padding: 0;
  border: 1px dashed #cbd3da;
  border-radius: 6px;
  background: #f8f9fa;
  color: #8898aa;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.variant-image-btn img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.variant-image-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.variant-image-delete {
  top: -6px;
  right: -6px;
  width: 16px;
  height: 16px;
  font-size: 8px;
}
.bodega-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
}
.bodega-row:last-child {
  border-bottom: 0;
}
.bodega-name {
  font-size: 0.875rem;
  font-weight: 500;
}

/* Fotos adicionales del producto */
.inv-photos-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}
.inv-photo-thumb {
  position: relative;
  aspect-ratio: 1 / 1;
  border-radius: 8px;
  overflow: hidden;
  background: #f4f5f7;
}
.inv-photo-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.inv-photo-delete {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 22px;
  height: 22px;
  border-radius: 999px;
  border: none;
  background: rgba(18, 18, 18, 0.7);
  color: #fff;
  font-size: 11px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s;
}
.inv-photo-delete:hover {
  background: #f5365c;
}
.inv-photo-delete:disabled {
  opacity: 0.5;
  cursor: default;
}
</style>
